<template>
  <div class="lisaBadge border-round" :style="colorProperties">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import chroma from "chroma-js";
import { getContrastColor } from "@/functions/colorHelper";

const props = defineProps({
  color: {
    type: String,
    default: "#FFFFFF00",
  },
});

function resolveCssColor(color: string) {
  const div = document.createElement("div");
  div.style.color = color;

  document.body.appendChild(div);

  const resolved = getComputedStyle(div).color;

  document.body.removeChild(div);

  return resolved;
}

const colorProperties = computed(() => {
  const newColor = props.color ? resolveCssColor(props.color) : "";
  const color = chroma.valid(newColor) ? chroma(newColor) : null;
  return {
    background: props.color,
    border: `1px solid ${color?.darken() ?? "lightGray"}`,
    color: getContrastColor(color),
  };
});
</script>

<style lang="scss" scoped>
.lisaBadge {
  display: inline-block;
  padding: 2.5px 7px;
  font-size: 1em;
  white-space: nowrap;
}
</style>
